export default {
  jobs: [
    {
      jobId: 30,
      title: 'Consultor SuccessFactors Employee Central (EC)',
      description: 'Atuar em projetos e suporte',
      companyId: 9,
      company: 'STRONG',
      jobStatusId: 1,
      categoryId: 1,
      responsibilities: 'Experiência em projetos de Employee Central (EC)',
      requirements: 'Inglês e espanhol avançados\nCertificação\nConhecimento em Recrutamento e Onboarding',
      benefits: '10 dias úteis de recesso remunerado após um ano de contrato.\nTreinamentos internos.\nGinástica Laboral online.\nAvaliação de desempenho anual.\nAcompanhamento de carreira.',
      location: 'São Paulo/SP',
      abroad: false,
      country: null,
      level: 'Senior',
      salary: '70 - 120',
      deadline: '2023-12-31T00:00:00',
      periodId: 1,
      period: 'Integral',
      workModelId: 2,
      workModel: 'Remoto',
      rewardTypeId: 4,
      hiringTypeId: 2,
      showSalary: false,
      companyEmail: 'luciene.freitas@strongit.com.br',
      hiringType: {
        hiringTypeId: 2,
        title: 'PJ',
      },
      indications: [],
    },
    {
      jobId: 72,
      title: 'Senior QA Automation Engineer | Portugal',
      description: 'Who is DBServices ?\n\nWe are positioned to help organizations in their digital transformation process by promoting innovation and optimizing legacy systems with our Digital Services. We are a spinoff of DBServer in Portugal, one of the largest and best software development companies in Brazil with more than 28 years of experience and 500+ projects successfully delivered.\n\nObs.: This position is to work in Porto or Lisboa (Portugal). We support the migration process with everything needed.',
      companyId: 2,
      company: '2BRAIN Consultoria e Estratégia Ltda',
      jobStatusId: 1,
      categoryId: 1,
      responsibilities: 'Planning, creation of prioritization strategies and test script execution;\nCreate and maintain pipelines to keep the regression up to date;\nCreate test script drafts in early stages;\nManage and report defects found through pipelines;\nManagement of automation tasks by projects;\nKeep testing artifacts (projects, scripts and pipelines) up to date;\nWork with test diversification techniques.',
      requirements: "Basic English reading and writing required;\nWorking with agile methodologies and practices: Kanban, small teams, strong communication and constant interaction;\nProgramming logic;\nCapability of apprehensibility of the products;\nCode versioning - Git;\nGood code practices: reuse, atomicity, low maintenance effort, integration strategy and low complexity;\nGherkin's knowledge;\nWeb-type test (endToend): Selenium (requirement used with any language. Concepts do not change);\nService Test: API Rest.",
      benefits: 'A collaborative environment, with sense of community;\nThe opportunity to meet people from different countries and cultures;\nPersonal and professional development program with full access to the Alura courses platform;\nThe chance to start or to continue your International Career.',
      location: 'São Paulo/SP',
      abroad: false,
      country: null,
      level: 'Senior',
      salary: '15000 - 15000',
      deadline: '2022-12-31T00:00:00',
      periodId: 1,
      period: 'Integral',
      workModelId: 2,
      workModel: 'Remoto',
      rewardTypeId: 1,
      hiringTypeId: 2,
      showSalary: false,
      companyEmail: 'andredias@2brain.com.br',
      hiringType: {
        hiringTypeId: 2,
        title: 'PJ',
      },
      indications: [],
    },
    {
      jobId: 73,
      title: 'Mobile Engineer (React Native) | Portugal',
      description: 'Who is DBServices ?\n\nWe are positioned to help organizations in their digital transformation process by promoting innovation and optimizing legacy systems with our Digital Services. We are a spinoff of DBServer in Portugal, one of the largest and best software development companies in Brazil with more than 28 years of experience and 500+ projects successfully delivered.\n\nObs.: Remote start and migration to Portugal in up to 4 months, hybrid.',
      companyId: 2,
      company: '2BRAIN Consultoria e Estratégia Ltda',
      jobStatusId: 1,
      categoryId: 1,
      responsibilities: 'Participate in the design and development of the new UI/UX;\nMaintain and refactor code of the mobile apps;\nDevelop new features to the mobile apps following the best code practices;\nDesign code which is easy to read and maintain (clean code);\nTroubleshoot and debug mobile apps together with API communication;\nWrite unit and integration tests during coding (TDD);\nSupport product management on the technical side of specifications.',
      requirements: 'University degree in Computer Science or similar;\n5+ years with experience in mobile development;\nIn-depth knowledge and experience with React, Redux and React Native;\nKnowledge about security and modern authentication mechanisms;\nKnowledge about offline-first capabilities and storage technologies;\nExperience with REST APIs and on CI/CD processes for mobile;\nWorking experience with agile methods like Scrum;\nGood interpersonal and communications skills;\nProficiency in English.\n',
      benefits: 'A collaborative environment, with sense of community;\nThe opportunity to meet people from different countries and cultures;\nPersonal and professional development program with full access to the Alura courses platform;\nThe chance to start or to continue your International Career.',
      location: 'São Paulo/SP',
      abroad: false,
      country: null,
      level: 'Senior',
      salary: '17000 - 20000',
      deadline: '2022-12-31T00:00:00',
      periodId: 1,
      period: 'Integral',
      workModelId: 3,
      workModel: 'Híbrido',
      rewardTypeId: 1,
      hiringTypeId: 2,
      showSalary: false,
      companyEmail: 'andredias@2brain.com.br',
      hiringType: {
        hiringTypeId: 2,
        title: 'PJ',
      },
      indications: [],
    },
    {
      jobId: 77,
      title: 'Sem Parar - Analista de CRM Junior',
      description: 'Responsável pela gestão de campanhas e jornadas de CRM (Email, SMS, Push e Whatsapp):e gestão de conteúdo e segmentação para disparos;',
      companyId: 2,
      company: '2BRAIN Consultoria e Estratégia Ltda',
      jobStatusId: 1,
      categoryId: 1,
      responsibilities: 'Campanhas\n\n• Orquestração de campanhas: gestão de pautas, calendarização.\n\n• Set up dos disparos; configuração das jornadas.\n\n Testes & Aprendizados\n\n• Gestão de backlog de testes\n\n• Estruturação de pilotos\n\nDados\n\n• Estruturação de dados na ferramenta de disparos de CRM (SalesForce)',
      requirements: 'Ensino Superior completo;\nExperiência em relatórios gerenciais ;\nExperiência com  apresentações;\nExperiência com  análises de dados (internos e de mercado);\nExperiência com campanhas de comunicação.',
      benefits: null,
      location: 'São Paulo/SP',
      abroad: false,
      country: null,
      level: 'Junior',
      salary: '3500 - 5000',
      deadline: '2023-04-15T00:00:00',
      periodId: 1,
      period: 'Integral',
      workModelId: 3,
      workModel: 'Híbrido',
      rewardTypeId: 4,
      hiringTypeId: 1,
      showSalary: false,
      companyEmail: 'andredias@2brain.com.br',
      hiringType: {
        hiringTypeId: 1,
        title: 'CLT',
      },
      indications: [],
    },
    {
      jobId: 78,
      title: 'Moove - Gerente de Projetos',
      description: '\nParte do grupo Cosan, a Moove é uma das maiores companhias de produção, venda e distribuição de lubrificantes do mundo. Além da nossa atuação no Brasil, estamos presentes em outros 10 países da América Latina, Europa e Estados Unidos.\n\nTemos uma trajetória de sucesso, que é resultado de parcerias estratégicas, inovação contínua e qualidade diferenciada dos produtos e serviços que oferecemos. Não abrimos mão de segurança, eficiência, desempenho e agilidade em nosso dia a dia. Isso é o que nos move para conquistar a confiança dos nossos clientes e parceiros e faz da Moove um dos grandes players do mercado. ',
      companyId: 2,
      company: '2BRAIN Consultoria e Estratégia Ltda',
      jobStatusId: 1,
      categoryId: 1,
      responsibilities: 'Realizar a gestão do desenvolvimento dos projetos:    \nDefinir escopo do projeto;   \nDefinir cronograma de entrega;    \nDefinir custos referente ao projeto;    \nAcompanhar a qualidade das entregas;    \nPrever os riscos de cada projeto;',
      requirements: 'Experiência com gestão de grandes projetos;\nExperiência com gestão de projetos em modelo Waterfall.\n\nDiferencial:\nExperiência com projetos de TMS;\nExperiência com projetos GKO.\n',
      benefits: null,
      location: '',
      abroad: false,
      country: null,
      level: 'Senior',
      salary: '10000 - 10000',
      deadline: '2023-04-15T00:00:00',
      periodId: 1,
      period: 'Integral',
      workModelId: 3,
      workModel: 'Híbrido',
      rewardTypeId: 4,
      hiringTypeId: 1,
      showSalary: false,
      companyEmail: 'andredias@2brain.com.br',
      hiringType: {
        hiringTypeId: 1,
        title: 'CLT',
      },
      indications: [],
    },
    {
      jobId: 79,
      title: 'Moove - Business Partner de TI',
      description: 'Parte do grupo Cosan, a Moove é uma das maiores companhias de produção, venda e distribuição de lubrificantes do mundo. Além da nossa atuação no Brasil, estamos presentes em outros 10 países da América Latina, Europa e Estados Unidos.\n\nTemos uma trajetória de sucesso, que é resultado de parcerias estratégicas, inovação contínua e qualidade diferenciada dos produtos e serviços que oferecemos. Não abrimos mão de segurança, eficiência, desempenho e agilidade em nosso dia a dia. Isso é o que nos move para conquistar a confiança dos nossos clientes e parceiros e faz da Moove um dos grandes players do mercado. ',
      companyId: 2,
      company: '2BRAIN Consultoria e Estratégia Ltda',
      jobStatusId: 1,
      categoryId: 1,
      responsibilities: '• Ser responsável por entender as necessidades com a área de negócio e traduzir em requisitos funcionais, para o time de desenvolvimento;\n• Apoiar no desenho de novas soluções;\n• Execução de testes de internos de TI e acompanhamento de homologação junto aos usuários;\n• Validar o que foi desenvolvido com a área de negócio;\n• Planejamento e acompanhamento de go live;\n• Atualizar time de sustentação, sobre as novas mudanças no sistema.',
      requirements: '• Levantamento de Requisitos e elaboração de Especificação Funcional;\n• Ter atuado com projetos de implantação/melhorias em SAP ECC;\n• Habilidade com Metodologia de Gestão de Projetos e de Agilidade;\n• Planejamento e execução de testes;\n• Formação superior completa;',
      benefits: null,
      location: 'Rio de Janeiro/RJ',
      abroad: false,
      country: null,
      level: 'Senior',
      salary: '10000 - 10000',
      deadline: '2023-04-15T00:00:00',
      periodId: 1,
      period: 'Integral',
      workModelId: 3,
      workModel: 'Híbrido',
      rewardTypeId: 4,
      hiringTypeId: 1,
      showSalary: false,
      companyEmail: 'andredias@2brain.com.br',
      hiringType: {
        hiringTypeId: 1,
        title: 'CLT',
      },
      indications: [],
    },
    {
      jobId: 80,
      title: 'Moove - Gerente de Projetos',
      description: 'Parte do grupo Cosan, a Moove é uma das maiores companhias de produção, venda e distribuição de lubrificantes do mundo. Além da nossa atuação no Brasil, estamos presentes em outros 10 países da América Latina, Europa e Estados Unidos.\n\nTemos uma trajetória de sucesso, resultado de parcerias estratégicas, inovação contínua e qualidade diferenciada dos produtos e serviços que oferecemos. Não abrimos mão de segurança, eficiência, desempenho e agilidade em nosso dia a dia. Isso é o que nos move para conquistar a confiança dos nossos clientes e parceiros e faz da Moove um dos grandes players do mercado.',
      companyId: 2,
      company: '2BRAIN Consultoria e Estratégia Ltda',
      jobStatusId: 1,
      categoryId: 1,
      responsibilities: 'Realizar a gestão do desenvolvimento dos projetos:\n\nDefinir escopo do projeto;\n\nDefinir cronograma de entrega;\n\nDefinir custos referente ao projeto;\n\nAcompanhar a qualidade das entregas;\n\nPrever os riscos de cada projeto.',
      requirements: 'Experiência com gestão de projetos para a área de atendimento;\nExperiência com plataformas de atendimentos como: Zendesk, Twilio, Salesforce e etc;\nConhecer o conceito de atendimento de Service Desk.',
      benefits: null,
      location: 'Rio de Janeiro/RJ',
      abroad: false,
      country: null,
      level: 'Senior',
      salary: '10000 - 10000',
      deadline: '2023-04-15T00:00:00',
      periodId: 1,
      period: 'Integral',
      workModelId: 3,
      workModel: 'Híbrido',
      rewardTypeId: 4,
      hiringTypeId: 1,
      showSalary: false,
      companyEmail: 'andredias@2brain.com.br',
      hiringType: {
        hiringTypeId: 1,
        title: 'CLT',
      },
      indications: [],
    },
  ],
}
